<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="6">
            <el-form-item label="页面背景色号">
              <el-input size="medium" v-model="form.background_color" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.background_color,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
         <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import {
  configInfo,saveHomeConfig
} from "@/api/mall";

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        background_color:'',
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      configInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.info = response.data
        this.form.background_color = response.data;
      });
    },
    uploadSuccess(value){
      this.form[value.formName] = value.fileUrl
    },
    onSave(){
      this.onSaveLoading = true;
      let that = this
      saveHomeConfig({
        background_color: this.form.background_color
      }).then(res => {
        that.onSaveLoading = false;
        if(res.code == 1){
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });
    },
    backPrePage(){
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
</style>